import React, { Suspense, useEffect, useRef } from 'react'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { generateRoutes } from './store/reducers/permissionSlice'
import { fetchUserInfoAsync } from './store/reducers/userSlice'
import { menuData } from './router/index'
import { getToken } from '@/global.config'
import Loading from './components/base/loading'

const whiteList = ['/login', '/ailogin'] // 添加ailogin到白名单

export default function App() {
  const dispatch = useDispatch()
  const routes = useSelector(state => state.permission.routes)
  const existingUserInfo = useSelector((state: any) => state.user.userInfo)

  // 跳转方法
  const navigate = useNavigate()
  const location = useLocation()

  const routeStore = useRef<{
    hasInitial: boolean
  }>({
    hasInitial: false
  })
  useEffect(() => {
    if (!whiteList.includes(location.pathname)) {
      if (getToken()) {
        if (!routeStore.current.hasInitial) {
          routeStore.current.hasInitial = true

          if (existingUserInfo) {
            dispatch(generateRoutes(menuData, existingUserInfo.menus))
          } else {
            dispatch(generateRoutes(menuData))
            dispatch(fetchUserInfoAsync()).unwrap().then((userInfo) => {
              dispatch(generateRoutes(menuData, userInfo.menus))
            }).catch(() => { })
          }
        }
      } else {
        navigate('/login', { replace: true, state: { preLocation: location } })
      }
    } else {
      routeStore.current.hasInitial = false
    }
  }, [location])

  const element = useRoutes(routes)
  //
  return (
    // <KeepAlive>
    <Suspense fallback={null}>{routes && element}</Suspense>
    // </KeepAlive>
  )
}
